const {REACT_APP_TECH_SCHOOL_AUTH_ORIGIN_URL} = process.env;

export const redirectToCourse = () => {
    window.location.href = `${REACT_APP_TECH_SCHOOL_AUTH_ORIGIN_URL}`
}